module.exports = __webpack_public_path__ + "assets/f4416aee4d33c14db0f54ef6feb65f2f.png";